module.exports = __webpack_public_path__ + "img/pic_kh.a9d1f1fe.png";